import { StatusService } from './status.service';
import { LocalStorageService } from './local-storage.service';
import { Component } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { QUESTION_DATA } from './questionnaire/questionData';
import { register } from 'swiper/element/bundle';

register();

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  testStatus: string;

  constructor(
    private menu: MenuController,
    private statusService: StatusService) {}

  updateState(){
    if (!this.statusService.hasTestStarted()){
      this.testStatus = 'test_not_started';
    }
    else if(!this.statusService.hasTestFinished()){
      this.testStatus = 'test_started';
    }
    else if(this.statusService.hasTestFinished()){
      this.testStatus = 'test_finished';
    }
  }

  ionWillOpen(e){
    console.log(e);
  }

}
